// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import "../../style/sassStyle";

import { isSignedIn, useAuthState } from "store/auth";

import { Box } from "@material-ui/core";
import { CustomerConfig } from "utils/ConfigTypes";
import Grid from "@material-ui/core/Grid";
import { OrgCard } from "./OrgCard";
import PageContent from "../ui/PageContent";
import Paragraph from "components/ui/Paragraph";
import React from "react";
import SignOutButton from "components/Login/SignOutButton";
import Title from "components/ui/Title";
import useCenteredStyle from "style/useCenteredStyle";
import { useConfigState } from "store/config";

interface OrgSelectionProps {
  customerConfigs: CustomerConfig[];
}

export default (props: OrgSelectionProps) => {
  const { config } = useConfigState();
  const { customerConfigs } = props;
  const classes = useCenteredStyle();
  const authState = useAuthState();

  if (!config) {
    return <div />;
  }

  let rows: JSX.Element | null = null;
  if (customerConfigs.length > 0) {
    let currentRowItems: Array<JSX.Element> = [];
    customerConfigs.forEach((customerConfig: CustomerConfig, index: number) => {
      currentRowItems.push(
        <Grid item xs={12} sm={6} md={4} key={`${customerConfig.id}-griditem`}>
          <OrgCard customerConfig={customerConfig} />
        </Grid>
      );
      if (index === customerConfigs.length - 1) {
        rows = (
          <Grid container spacing={3}>
            {currentRowItems}
          </Grid>
        );
        currentRowItems = [];
      }
    });
  }

  return (
    <PageContent>
      <div className={classes.centeredContent}>
        <Title>Welcome to OpenRDT</Title>
        <Paragraph>Select an organization below to continue.</Paragraph>
        <div className="container">{rows}</div>
        {isSignedIn() && (
          <Box padding={4}>
            <Paragraph>
              Currently signed in as: {authState.auth?.email}
            </Paragraph>
            <SignOutButton />
          </Box>
        )}
      </div>
    </PageContent>
  );
};
